import styled from 'styled-components';
import { getBreakpoint } from '../utils';

const breakpoint = getBreakpoint();

export const RefundsSeparator = styled.hr`
  width: 100%;
  border: 0.5px solid #cfcfcf;
  margin: 0;
`;

export const RefundsDescription = styled.div`
  font-size: 18px;
  line-height: 120%;

  h1 {
    font-size: 25px;
    line-height: 120%;
    margin: 1em 0;

    @media ${breakpoint} {
      font-size: 30px;
      margin: 1em 30px;
    }
  }

  p {
    line-height: 120%;
    margin: 1em 0 2em 0;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/components/CommonComponents.ts